import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import useFetch from "../../../../../hooks/useFetch";
import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
} from "@mui/material";
import ShareStepper from "../../../../shares/stepper/Stepper";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import useFormattedLocalDate from "../../../../../hooks/useFormattedLocalDate";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const AddVideos = forwardRef(({ close, get, edit }, ref) => {
  const [call, setCall] = useState({
    ClassroomName: "",
    classroom_headline: "",
    classroom_available_time_end: "",
    classroom_presence: "",
    classroom_groups: [],
    content1_url1: "",
    content2_url1: "",
    content3_url1: "",
    content4_url1: "",
    content5_url1: "",
    assignment_info: null,
  });
  const [groups, setGroups] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const formatDate = useFormattedLocalDate();

  const handleNext = (event) => {
    event.preventDefault();
    setActiveStep((prevStep) => prevStep + 1);
  };

  const onSubmit = (data) => {
    if (edit) {
      editClassroom.reFetch();
    } else {
      newVideo.reFetch();
    }
  };

  const getGroup = useFetch({
    method: "GET",
    url: `management/groups/?page_size=1000`,
    noHeader: false,
    trigger: true,
    setter: setGroups,
  });

  const newVideo = useFetch({
    method: "POST",
    url: `management/classrooms/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const editClassroom = useFetch({
    method: "PATCH",
    url: `management/classrooms/${edit}/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });
  const getClassroom = useFetch({
    method: "GET",
    url: `management/classrooms/${edit}/`,
    noHeader: false,
    trigger: edit ? true : false,
    setter: setCall,
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const handleCheckboxChange = (event) => {
    const value = parseInt(event.target.value);
    const currentIndex = call?.classroom_groups.indexOf(value);
    const newChecked = call?.classroom_groups;

    if (currentIndex === -1) {
      if (newChecked.length < groups.results.length) {
        newChecked.push(value);
      }
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCall({ ...call, classroom_groups: newChecked });
  };

  const steps = ["مرحله اول", "مرحله دوم"];
  const isLastStep = activeStep === steps.length - 1;

  useEffect(() => {
    newVideo.status === 201 && close();
    editClassroom.status === 200 && close();
  }, [newVideo.status || editClassroom.status]);

  // useEffect(() => {
  //   if (edit && call.classroom_available_time_end && isFirstRender) {
  //     setCall({
  //       ...call,
  //       classroom_available_time_end: new Date(
  //         call.classroom_available_time_end
  //       ),
  //     });
  //     isFirstRender.current = false;
  //   }
  // }, [call]);

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={edit ? "ویرایش درس" : "درس جدید"}
      subtitle="مشخصات درس، ویدیوها و گروه‌ها"
      width="max-w-[56rem]"
    >
      <ShareStepper steps={steps} activeStep={activeStep} onNext={handleNext} />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-lg flex flex-col gap-lg text-sm"
      >
        {activeStep === 0 && (
          <>
            <div>
              <label htmlFor="ClassroomName" className="mb-2xs block text-sm text-ink-muted">
                عنوان
              </label>
              <TextField
                name="ClassroomName"
                value={call.ClassroomName}
                placeholder="عنوان"
                {...register("ClassroomName", {
                  required: "عنوان را وارد کنید",
                })}
                error={!!errors.ClassroomName}
                helperText={
                  errors.ClassroomName ? errors.ClassroomName.message : ""
                }
                onChange={(e) => {
                  setCall({ ...call, ClassroomName: e.target.value });
                }}
                fullWidth
              />
            </div>

            <div>
              <label htmlFor="class" className="mb-2xs block text-sm text-ink-muted">
                مبحث
              </label>
              <FormControl
                error={errors.classroom_headline ? true : false}
                fullWidth
              >
                <Select
                  value={call.classroom_headline}
                  {...register("classroom_headline", {
                    required: "مبحث را وارد کنید",
                  })}
                  fullWidth
                  onChange={(e) => {
                    setCall({ ...call, classroom_headline: e.target.value });
                  }}
                >
                  {lessons.map((lesson) => {
                    return <MenuItem value={lesson}>{lesson}</MenuItem>;
                  })}
                </Select>
                <FormHelperText>{errors?.group_day?.message}</FormHelperText>
              </FormControl>
            </div>
            <div>
              <label htmlFor="end-day" className="mb-2xs block text-sm text-ink-muted">
                روز پایان
              </label>

              <MobileDatePicker
                label="روز پایان"
                onChange={(e) => {
                  const date = formatDate(e);
                  setCall((prev) => ({
                    ...prev,
                    classroom_available_time_end: date,
                  }));
                }}
                value={
                  call.classroom_available_time_end
                    ? new Date(call.classroom_available_time_end)
                    : null
                }
                views={["year", "month", "day"]}
                className="!text-6xl w-full"
                slotProps={{
                  field: { shouldRespectLeadingZeros: true },
                  toolbar: { hidden: true },
                  tabs: { hidden: true },
                }}
              />
            </div>
            <div>
              <label htmlFor="class" className="mb-2xs block text-sm text-ink-muted">
                حضور و غیاب
              </label>
              <FormControl
                error={errors.classroom_presence ? true : false}
                fullWidth
              >
                <RadioGroup
                  value={call.classroom_presence}
                  {...register("classroom_presence", {
                    required: "حضور و غیاب را وارد کنید",
                  })}
                  id="class"
                  fullWidth
                  sx={{
                    flexDirection: "row",
                    "& .css-j204z7-MuiFormControlLabel-root": {
                      marginLeft: "0px",
                      marginRight: "0px",
                    },
                  }}
                  onChange={(e) => {
                    setCall({ ...call, classroom_presence: e.target.value });
                  }}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="داشته باشد"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="نداشته باشد"
                  />
                </RadioGroup>
                <FormHelperText>
                  {errors?.classroom_presence?.message}
                </FormHelperText>
              </FormControl>
            </div>

            <div>
              <label htmlFor="content1_url1" className="mb-2xs block text-sm text-ink-muted">
                لینک ویدئوی اول
              </label>
              <TextField
                name="content1_url1"
                value={call.content1_url1}
                placeholder="عنوان"
                {...register("content1_url1", {
                  required: "این فیلد اجباری است",
                })}
                error={!!errors.content1_url1}
                helperText={
                  errors.content1_url1 ? errors.content1_url1.message : ""
                }
                onChange={(e) => {
                  setCall({ ...call, content1_url1: e.target.value });
                }}
                fullWidth
              />
            </div>
            <div>
              <label htmlFor="content2_url1" className="mb-2xs block text-sm text-ink-muted">
                لینک ویدئوی دوم
              </label>
              <TextField
                name="content2_url1"
                value={call.content2_url1}
                placeholder="عنوان"
                {...register("content2_url1", {})}
                onChange={(e) => {
                  setCall({ ...call, content2_url1: e.target.value });
                }}
                fullWidth
              />
            </div>
            <div>
              <label htmlFor="content3_url1" className="mb-2xs block text-sm text-ink-muted">
                لینک ویدئوی سوم
              </label>
              <TextField
                name="content3_url1"
                value={call.content3_url1}
                placeholder="عنوان"
                {...register("content3_url1", {})}
                onChange={(e) => {
                  setCall({ ...call, content3_url1: e.target.value });
                }}
                fullWidth
              />
            </div>
            <div>
              <label htmlFor="content4_url1" className="mb-2xs block text-sm text-ink-muted">
                لینک ویدئوی چهارم
              </label>
              <TextField
                name="content4_url1"
                value={call.content4_url1}
                placeholder="عنوان"
                {...register("content4_url1", {
                  required: "این فیلد اجباری است",
                })}
                onChange={(e) => {
                  setCall({ ...call, content4_url1: e.target.value });
                }}
                fullWidth
              />
            </div>
            <div>
              <label htmlFor="content5_url1" className="mb-2xs block text-sm text-ink-muted">
                لینک ویدئوی پنجم
              </label>
              <TextField
                name="content5_url1"
                value={call.content5_url1}
                placeholder="عنوان"
                {...register("content5_url1", {
                  required: "این فیلد اجباری است",
                })}
                onChange={(e) => {
                  setCall({ ...call, content5_url1: e.target.value });
                }}
                fullWidth
              />
            </div>
          </>
        )}
        {activeStep === 1 && (
          <>
            <div>
              <label htmlFor="classroom_groups" className="mb-2xs block text-sm text-ink-muted">
                گروه
              </label>
              <FormControl
                error={errors.classroom_groups ? true : false}
                fullWidth
              >
                <FormGroup id="classroom_groups" fullWidth>
                  {groups?.results.map((group) => {
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              call?.classroom_groups.indexOf(group.id) !== -1
                            }
                          />
                        }
                        label={group.name}
                        value={group.id}
                        onChange={handleCheckboxChange}
                      />
                    );
                  })}
                </FormGroup>
                <FormHelperText>
                  {errors?.classroom_groups?.message}
                </FormHelperText>
              </FormControl>
            </div>
          </>
        )}
        <div className="flex justify-end border-t border-rule-subtle pt-lg">
          {isLastStep ? (
            <button
              disabled={
                call.ClassroomName &&
                call.classroom_headline &&
                call.classroom_available_time_end &&
                call.classroom_presence !== "" &&
                call.content1_url1
                  ? false
                  : true
              }
              type="submit"
              className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 motion-reduce:transition-none"
            >
              ثبت درس
            </button>
          ) : (
            <button
              type="button"
              onClick={handleNext}
              disabled={
                !(
                  call.ClassroomName &&
                  call.classroom_headline &&
                  call.classroom_available_time_end &&
                  call.content1_url1
                )
              }
              className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 motion-reduce:transition-none"
            >
              بعدی
            </button>
          )}
        </div>
      </form>
    </ModalShell>
  );
});

export default AddVideos;

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

const lessons = [
  "توابع و خواص آن ها",
  "معادله درجه دوم",
  "الگو و دنباله",
  "مثلثات",
  "توان های گویا و عبارات جبری",
  "مرور توابع و خواص آن ها",
  "آنالیز",
  "احتمالات",
  "هندسه مختصاتی",
  "معادلات و نامعادلات گویا و گنگ",
  "قدر مطلق",
  "براکت",
  "هندسه",
  "توابع نمایی و لگاریتم",
  "حد",
  "پیوستگی",
  "بخش پذیری",
  "مشتق",
  "کاربرد مشتق",
  "مجانب ها",
  "مقاطع مخروطی",
];
